<template>
    <div> 
        <div class="row">
            <div class="col-lg-8">
                <h4 v-if="admon">Cuenta Administración <br><b>{{ cta.user }} </b></h4>
                <h4 v-else>Cambiar Contraseña</h4>
                
                <b-form @submit.prevent="submit" v-show="!admon">                      
                    <div class="form-row">                               
                        <b-form-group label="Contraseña Actual" class="col-sm-12"> 
                            <b-input-group>
                                <b-form-input ref="pas" v-model="cta.pas" required trim :type="type"></b-form-input>
                                <b-input-group-prepend is-text @click="visible=!visible">
                                    <!-- <b-icon-eye-slash-fill/> -->
                                    <b-icon :icon="icono"></b-icon>
                                </b-input-group-prepend>                             
                            </b-input-group>                                                            
                        </b-form-group>                    
                    </div>
                    <div class="form-row">                                                                   
                        <b-form-group label="Nueva Contraseña" class="col-sm-12">                            
                            <b-form-input ref="new" v-model="cta.new" required trim :type="type"></b-form-input>
                        </b-form-group>                    
                    </div>
                    <div class="form-row">                                                                   
                        <b-form-group label="Confirmar Nueva Contraseña" class="col-sm-12">                            
                            <b-form-input ref="con" v-model="cta.con" required trim :type="type"></b-form-input>
                        </b-form-group>                    
                    </div>
                    <hr>
                    <b-button type="submit" block variant="success">cambiar Contraseña</b-button>            
                </b-form>                

            </div>
<!-- Informacion Derecha -->
            <div class="col-lg-4 mt-4 mt-lg-0">
                <div class="bg-light-2 p-3">
                    <p class="mb-2">Importante completar</p>
                    <p class="small">En caso de reservas con más de una persona es imprescindible
                        rellenar el DNI de todos y cada uno de los viajeros.</p>
                    <hr>
                    <p class="mb-2">Mensajes de alertas</p>
                    <p class="small">Aquí se pueden mostrar alertas u otros mensajes de interés para
                        el usuario. </p>
                </div>
            </div>
        </div>                                                  

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'cambio-password',
    components: {
        //publicidad,
    },
    data() {
        return {
            cta: { pas:'', new:'', con:'' },

            submitted: false,
            message: 'Error', 

            visible: false,
        };
    },
    computed: {        
        ...mapState(['auth','errores']),

        /* cta() {
            return this.auth.user;
        }, */
        admon() {
            return (this.cta.dep=='ADMON');
        },      
        type() {
            return (this.visible ? 'text' : 'password');
        },
        icono() {
            return (this.visible ? 'eye-slash-fill' : 'eye-fill');
        }, 
        
    },
    methods: {
        ...mapMutations(['loading','alerta','modal','showModal']),
        ...mapActions(['exec']),

        submit(evt) { 
            evt.preventDefault();            

            //validacion errores
            if (!this.validar()) return;

            this.submitted=true;                                
            this.enviar();
        },
        async enviar() {
            //this.loading();

            var args={token: this.auth.token, pas: this.cta.pas, new: this.cta.new};            
            let r=await this.exec({api:'info_password', arg: args });

            let msg=r.error ? r.datos : 'Datos Guardados correctamente';
            //this.$store.commit('modal','Información Personal',msg);
            this.modal({tit:"Cambio Contraseña", msg:msg});

            this.submitted=false;
            //this.loading(false);

            //this.$router.push('/');
        },

        validar() {
            //controlar errores passwords
            var msg='';

            if (this.cta.pas==this.cta.new) {
                msg+='La nueva contraseña no puede ser la misma que la actual';                
                this.$refs.new.focus();

            } else {
                let res=this.validPass(this.cta.new,this.cta.con);
                if (!res.valid) {
                    res.errors.forEach((value) => {
                        msg+=value+"<br>";                      
                    });
                    this.$refs.new.focus();
                }
            }
            if (msg>'') this.modal({tit:"Cambio Contraseña", msg:msg});                                            
            return (msg==='');
        },
        
        validPass(pass,check) {
            let errors=[];
            if (pass=='' || check=='') errors.push("Debe rellenar el Password/Contraseña");
            if (pass!== check) errors.push("Las contraseñas Nuevasintroducidas no coinciden");

            var rules=[
                { msg:"Mínimo 6 caracteres", regex:/.{6,}/ },
                { msg:"Un carácter numérico", regex:/[0-9]+/ },
                { msg:'Un caracter en minúscula', regex:/[a-z]+/ },
                { msg:"Un caracter en mayusculas",  regex:/[A-Z]+/ },								
                { msg:"Un caracter especial (,;.:-_+*!$%&=)",  regex:/[,;.:-_+*!$%&=]+/ },								
            ];

            for (let condition of rules) {
				if (!condition.regex.test(pass)) {
					errors.push(condition.msg)
				}
            }
            return { valid: (errors.length === 0), errors };			
        },     
        
    },
}
</script>
